<template>
<v-card class="panel"  elevation="1">
    <div class="account">
        <div class="form-header">
            <p class="form-label">{{ $page.props.lang.title || "Account Details" }}</p>
        </div>
        <div class="fields">
            <div class="grid">
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.firstName || 'First name' }}</p>
                    <v-text-field v-model="form.first_name" outlined dense
                    :error-messages="responseErrors.first_name" @focus="responseErrors.first_name=''"
                    ></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.lastName || 'Last name' }}</p>
                    <v-text-field v-model="form.last_name" outlined dense
                    :error-messages="responseErrors.last_name" @focus="responseErrors.last_name=''"></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.birthDate || 'Day of birth' }}</p>
                    <v-menu
                    ref="birthDatePicker"
                    v-model="birthDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="formatDatePicker"
                            append-icon="mdi-menu-down"
                            outlined dense readonly v-bind="attrs" v-on="on"
                            @click:append="birthDatePicker = true" :hide-details="!responseErrors.birth_date"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="form.birth_date"
                            :min="minBirth" :max="yesterday"
                            :active-picker.sync="activePicker"
                            :first-day-of-week="1" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="birthDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="birthDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.gender || 'Gender' }}</p>
                    <v-select v-model="form.gender" :items="gender" outlined dense></v-select>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.email || 'E-mail' }}</p>
                    <v-text-field v-model="form.email" outlined dense
                    :error-messages="responseErrors.email" @focus="responseErrors.email=''"></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.phone || 'Phone number' }}</p>
                    <v-text-field v-model="form.phone_number"
                    :placeholder="country_code + 'xxxx...'" outlined dense
                    :error-messages="responseErrors.phone_number" @focus="responseErrors.phone_number=''"></v-text-field>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.card || 'Card number' }}</p>
                    <div class="card-id-wrap">
                        <v-text-field
                        v-model="form.card_id"
                        :error-messages="responseErrors.card_id" @focus="responseErrors.card_id=''"
                        :hint="$page.props.lang.scan || 'Scan your card'" outlined dense
                        ref="cardInput"></v-text-field>
                        <v-btn @click="$refs.cardInput.focus()" id="scan" class="focus-card-input">
                            <v-icon>mdi-tag-outline</v-icon>
                        </v-btn>
                        <v-tooltip activator="#scan" bottom open-delay="500">
                            <span>{{$page.props.lang.prepareScan || "Prepare scan"}}</span>
                        </v-tooltip>
                    </div>
                </div>
                <div class="field-group">
                    <p class="label">{{ $page.props.lang.defaultTrainer || 'Default Trainer' }}</p>
                    <v-select
                    v-model="form.trainer_id"
                    :items="trainers"
                    item-text="full_name" item-value="id" outlined dense
                    ></v-select>
                </div>

                <div v-for="field in customsData" class="field-group" :key="field.id">
                    <div v-if="field.type==='decimal' || field.type==='number' || field.type==='text'">
                        <p class="label">{{ field.label }}</p>
                        <v-text-field v-model="field.value"
                        :error-messages="customsErrors[field.id]" @focus="customsErrors[field.id]=''"
                        :type="field.type"
                        outlined dense></v-text-field>
                    </div>
                    <div v-if="field.type==='date'">
                        <p class="label">{{ field.label }}</p>
                        <v-menu
                        ref="menu"
                        v-model="customDatePicker"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="field.value || date | formatDate"
                                append-icon="mdi-menu-down" outlined dense readonly v-bind="attrs" v-on="on"
                                @click:append="customDatePicker = true"
                                :error-messages="customsErrors[field.id]" @focus="customsErrors[field.id]=''"></v-text-field>
                            </template>
                            <v-date-picker v-model="field.value"
                            :first-day-of-week="1" no-title scrollable color="primary">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="customDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                <v-btn text color="primary" @click="customDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                    <div v-if="field.type==='boolean'">
                        <v-checkbox v-model="field.value" :label="field.label"></v-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <v-btn @click="submitEdit" :loading="saving" color="primary" v-show="$page.props.p['members.manage']">{{ $page.props.lang.save || "Save" }}</v-btn>
        <v-btn @click="resetEdit" color="regular" v-show="$page.props.p['members.manage']">{{ $page.props.lang.reset || "Reset" }}</v-btn>
    </div>
</v-card>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import MemberLayout from './Layouts/Default'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title: this.$page.props.member.full_name + ' - '+ (this.$page.props.lang.title || "Account Details")
        }
    },
    layout: (h, page) => {
      return h(AppLayout, [
        h(MemberLayout, [page]),
      ])
    },
    props: {
        member: Object,
        trainers: Array,
        errors: Object,
        lang: Object,
        customs: Array,
        country_code: String
    },
    data(){
        return {
            form: {
                id: this.member.id,
                first_name: this.member.first_name,
                last_name: this.member.last_name,
                email: this.member.email,
                phone_number: this.member.phone_number,
                gender: this.member.gender,
                birth_date: this.member.birth_date,
                note: this.member.note,
                card_id: this.member.card_id,
                trainer_id: this.member.trainer_id,
                is_active: this.member.is_active,
                profile_photo_url: this.member.profile_photo_url
            },
            formReset: {
                id: this.member.id,
                first_name: this.member.first_name,
                last_name: this.member.last_name,
                email: this.member.email,
                phone_number: this.member.phone_number,
                gender: this.member.gender,
                birth_date: this.member.birth_date,
                note: this.member.note,
                card_id: this.member.card_id,
                trainer_id: this.member.trainer_id,
                is_active: this.member.is_active,
                profile_photo_url: this.member.profile_photo_url
            },
            birthDatePicker: false,
            activePicker: null,
            date: moment().format('YYYY-MM-DD'),
            minBirth: moment().subtract(100, 'years').format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            editMemberMessage: {
                value: false,
                text: '',
                color: ''
            },
            saving:false,
            responseErrors: {},
            deleteMembModal: false,
            messageObjects: [],
            customDatePicker: false,
            customsErrors: {}
        }
    },
    watch: {
        member(value) {
            this.form = value
            this.$parent.$emit('edited', this.form)
        },

        birthDatePicker (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
    },
    mounted() {
        this.$parent.$emit('edited', this.form)
    },
    computed: {
        gender() {
            let male = this.lang.male || 'Male';
            let female = this.lang.female || 'Female';
            let other = this.lang.other || 'Other';

            return [
                { text: male, value: 0 },
                { text: female, value: 1 },
                { text: other, value: 2 }
            ]
        },
        formattedDate() {
            let realDate = new Date(this.form.birth_date)
            let month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][realDate.getMonth()]
            let day = realDate.getDate()
            let year = realDate.getFullYear()
            return day + '. ' + month + ' ' + year + ''
        },

        formatDatePicker(){
            if(this.form.birth_date !== null){
                return moment(this.form.birth_date).format('D.M.Y');
            }else{
                return null;
            }
        },

        customsData() {
            return this.customs.map(item => {
                if (item.type==='boolean') {
                    item.value == '' ? item.value = false : item.value = true
                }
                return item
            })
        }
    },
    methods:{
        resetEdit() {
            this.form = Object.assign({}, this.formReset)
            this.responseErrors = {}
        },
        submitEdit() {
            this.form.birth_date = this.form.birth_date ? this.form.birth_date.substr(0, 10) : null;
            this.form.customs = Object.assign({}, this.customsData.map(item => {
                if (item.type==='boolean') {
                    item.value==true ? item.value = 1 : item.value = 0
                }
                return item
            }))
            for (let i=0; i<this.customsData.length; i++) {
                if (this.customsData[i].is_req===1) {
                    if (this.customsData[i].value==='' || this.customsData[i].value===null) {
                        this.customsErrors[this.customsData[i].id] = this.$page.props.locale === 'sr' ?
                        'Polje ' + this.customsData[i].label + ' je obavezno.'
                        : 'Field ' + this.customsData[i].label + ' is required.'
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: this.lang.editMemberMessageError || 'Member not edited.',
                                color: 'error',
                                timeout: 10000
                            })
                        return
                    }
                }
            }
            this.saving = true;
            axios.post('/backoffice/members/update', this.form)
                .then(response => {
                    this.saving = false;
                    if (response.data.status==="OK") {

                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        // this.$inertia.reload()
                        this.$parent.$emit('edited', response.data.member)

                        this.formReset = Object.assign({}, this.form)
                        this.sending = false
                    } else {
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'error',
                                timeout: 10000
                            })
                    }
                })
                .catch(error => {
                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        }
    }
}
</script>
